import React from 'react';
import { translate } from 'react-i18next';
import { createRoute } from 'lib/util';
import * as Common from 'common/components';

const { Form } = Common;

const CatalogsListHeader = ({ canAdd = false, companyId = '', subcompanyId = '', t }) => {
  return <Common.Header title={t('catalogs.catalogs_title')}></Common.Header>;
};

export default translate()(CatalogsListHeader);



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/components/list/CatalogsListHeader.js